var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TheFooter',[_c('div',[_c('span',{staticClass:"ml-1"},[_vm._v("© 2020 Mega Mulia. "+_vm._s(_vm.version))])])])}
var staticRenderFns = []

export { render, staticRenderFns }